module.exports = __webpack_public_path__ + "aw.dac08025bda75843ac67.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/vendors/flag-icon/flags/4x3/aw.svg
// module id = ../../../../../src/assets/vendors/flag-icon/flags/4x3/aw.svg
// module chunks = 0